<template>
	<div class="info-wrap">
		<p class="info-header">{{ tt('추가정보') }}</p>
		<div class="field-wrap">
			<custom-info-field
				v-for="fieldInfo in customFields"
				:item="item"
				:fieldInfo="fieldInfo"
				:isAcvite="fieldInfo.isActive"
				:isRequire="fieldInfo.isRequire"
				:key="`${fieldInfo.key}`"
				:fieldText="formatFieldText(fieldInfo)"
				:isData="isData(fieldInfo.key)"
				:fieldName="formatFieldName(fieldInfo)"
			></custom-info-field>
		</div>
	</div>
</template>
<script>
import MixinItem from '@/mixins/inventory/MixinItem'
import CustomInfoField from '@/views/inventoryGen2/components/detail/customInfo/field.vue'

export default {
	name: 'CustomInfo',
	components: { CustomInfoField },
	mixins: [MixinItem],
	props: {
		item: {
			type: Object,
			default: null,
		},
		customFields: {
			type: Array,
			default: null,
		},
		customFieldsData: {
			type: Object,
		},
	},
	data() {
		return {}
	},
	computed: {
		findFieldIdxByKeyName() {
			return keyname => this.managementFields?.findIndex(it => it.key == keyname)
		},
		categoryFields() {
			if (this.item) {
				return this.managementFields
			} else {
				return null
			}
		},
		formatFieldName() {
			return fieldInfo => fieldInfo?.name
		},
		formatFieldText() {
			return fieldInfo => {
				let key = fieldInfo?.key
				let value = this.customFieldsData?.[key]
				switch (fieldInfo?.varType) {
					case 'text_single_line_with_unit':
						return this.formatVolume(value, fieldInfo?.unit?.[0])
					case 'select_member':
						return value?.name
					case 'select_datetime':
					case 'select_option':
					case 'text_single_line':
					case 'text_multiple_line':
					default:
						return value ?? '-'
				}
			}
		},
		isData() {
			return key => {
				let value = this.customFieldsData?.[key]
				if (value) {
					switch (key) {
						default:
							return !!value
					}
				}
				return false
			}
		},
	},
	watch: {},
	created() {},
	mounted() {},
	methods: {},
}
</script>

<style lang="scss" scoped>
.info-wrap {
	display: flex;
	flex-direction: column;
	padding: 25px 0px;
	align-items: flex-start;
	border-bottom: 1px solid $DIVIDER;
	gap: 20px;
	.info-header {
		font-size: 16px;
		font-weight: 700;
	}
	.field-wrap {
		display: flex;
		flex-wrap: wrap;
		gap: 20px;
	}
}
</style>
